const orderPrices = {
  'Mała': 109,
  'Średnia': 159,
  'Duża': 219
};

const freeShippingThreshold = 215;

const formatZloty = (value) => `${Math.round(value)} zł`;

const readJsonScript = (selector, fallback = []) => {
  const source = document.querySelector(selector);

  if (!source) {
    return fallback;
  }

  try {
    return JSON.parse(source.textContent);
  } catch (error) {
    return fallback;
  }
};

const fallbackBowllyGiftVariant = {
  id: '65573714035037',
  available: true
};

const fallbackBowllyVariants = [
  { id: '65307721793885', options: ['Szary', 'Mała'], available: true },
  { id: '65309801382237', options: ['Szary', 'Średnia'], available: true },
  { id: '65309801415005', options: ['Szary', 'Duża'], available: true },
  { id: '65315250372957', options: ['Biały', 'Mała'], available: true },
  { id: '65315250405725', options: ['Biały', 'Średnia'], available: true },
  { id: '65315250438493', options: ['Biały', 'Duża'], available: true },
  { id: '65315250471261', options: ['Czarny', 'Mała'], available: true },
  { id: '65315250504029', options: ['Czarny', 'Średnia'], available: true },
  { id: '65315250536797', options: ['Czarny', 'Duża'], available: true },
  { id: '65315250569565', options: ['Pomarańczowy', 'Mała'], available: true },
  { id: '65315250602333', options: ['Pomarańczowy', 'Średnia'], available: true },
  { id: '65315250635101', options: ['Pomarańczowy', 'Duża'], available: true },
  { id: '65315250667869', options: ['Zielony', 'Mała'], available: true },
  { id: '65315250700637', options: ['Zielony', 'Średnia'], available: true },
  { id: '65315250733405', options: ['Zielony', 'Duża'], available: true },
  { id: '65315250766173', options: ['Beżowy', 'Mała'], available: true },
  { id: '65315250798941', options: ['Beżowy', 'Średnia'], available: true },
  { id: '65315250831709', options: ['Beżowy', 'Duża'], available: true }
];

const fallbackBowllyUpsellVariants = [
  { id: '65573751587165', options: ['Szary', 'Mała'], available: true },
  { id: '65573751619933', options: ['Szary', 'Średnia'], available: true },
  { id: '65573751652701', options: ['Szary', 'Duża'], available: true },
  { id: '65573751685469', options: ['Biały', 'Mała'], available: true },
  { id: '65573751718237', options: ['Biały', 'Średnia'], available: true },
  { id: '65573751751005', options: ['Biały', 'Duża'], available: true },
  { id: '65573751783773', options: ['Czarny', 'Mała'], available: true },
  { id: '65573751816541', options: ['Czarny', 'Średnia'], available: true },
  { id: '65573751849309', options: ['Czarny', 'Duża'], available: true },
  { id: '65573751882077', options: ['Pomarańczowy', 'Mała'], available: true },
  { id: '65573751914845', options: ['Pomarańczowy', 'Średnia'], available: true },
  { id: '65573751947613', options: ['Pomarańczowy', 'Duża'], available: true },
  { id: '65573751980381', options: ['Zielony', 'Mała'], available: true },
  { id: '65573752013149', options: ['Zielony', 'Średnia'], available: true },
  { id: '65573752045917', options: ['Zielony', 'Duża'], available: true },
  { id: '65573752078685', options: ['Beżowy', 'Mała'], available: true },
  { id: '65573752111453', options: ['Beżowy', 'Średnia'], available: true },
  { id: '65573752144221', options: ['Beżowy', 'Duża'], available: true }
];

const getVariantMap = (selector) => readJsonScript(selector, []).map((variant) => {
  const options = [
    variant.title,
    variant.option1,
    variant.option2,
    variant.option3,
    ...(Array.isArray(variant.options) ? variant.options : [])
  ].filter(Boolean);

  return {
    id: String(variant.id || ''),
    available: variant.available,
    options
  };
}).filter((variant) => variant.id && variant.options.length);

const liquidBowllyVariants = getVariantMap('[data-bowlly-variants]');
const liquidUpsellVariants = getVariantMap('[data-bowlly-upsell-variants]');
const mergeVariantMaps = (...variantMaps) => {
  const seen = new Set();

  return variantMaps.flat().filter((variant) => {
    if (!variant?.id || seen.has(variant.id)) {
      return false;
    }

    seen.add(variant.id);
    return true;
  });
};

const liquidGiftVariant = readJsonScript('[data-bowlly-gift-variant]', null);
const bowllyVariants = mergeVariantMaps(fallbackBowllyVariants, liquidBowllyVariants);
const bowllyUpsellVariants = mergeVariantMaps(fallbackBowllyUpsellVariants, liquidUpsellVariants);
const bowllyGiftVariant = liquidGiftVariant?.id
  ? { id: String(liquidGiftVariant.id), available: liquidGiftVariant.available }
  : fallbackBowllyGiftVariant;

let isCartPreparedForCheckout = false;
let selectedDeliveryPoint = null;
let deliveryPointStore = new Map();

const setText = (selector, value) => {
  document.querySelectorAll(selector).forEach((element) => {
    element.textContent = value;
  });
};

const getSelectedOrderSize = () => document.querySelector('[data-order-size].is-selected')?.dataset.orderSize || 'Mała';

const getSelectedOrderColor = () => document.querySelector('[data-order-color].is-selected')?.dataset.orderColor || 'Szary';

const getUpsellColorMode = () => document.querySelector('[name="upsell-color-mode"]:checked')?.value || 'same';

const getSelectedUpsellColorButton = () => document.querySelector('[data-upsell-color].is-selected');

const getSelectedUpsellColor = () => getUpsellColorMode() === 'different'
  ? getSelectedUpsellColorButton()?.dataset.upsellColor || getSelectedOrderColor()
  : getSelectedOrderColor();

const ensureDifferentUpsellColor = () => {
  const orderColor = getSelectedOrderColor();
  const buttons = Array.from(document.querySelectorAll('[data-upsell-color]'));
  let selected = getSelectedUpsellColorButton();

  if (!selected || selected.dataset.upsellColor === orderColor) {
    selected = buttons.find((button) => button.dataset.upsellColor !== orderColor) || buttons[0];
  }

  buttons.forEach((button) => {
    button.classList.toggle('is-selected', button === selected);
  });

  return selected;
};

const updateUpsellColorDisplay = () => {
  const usesDifferentColor = getUpsellColorMode() === 'different';
  const sourceButton = usesDifferentColor
    ? ensureDifferentUpsellColor()
    : document.querySelector('[data-order-color].is-selected');
  const color = usesDifferentColor
    ? sourceButton?.dataset.upsellColor || getSelectedOrderColor()
    : getSelectedOrderColor();
  const image = sourceButton?.dataset.colorImage;

  if (image) {
    document.querySelectorAll('.dtc-water-upsell__image img, [data-upsell-summary-image]').forEach((upsellImage) => {
      upsellImage.src = image;
      upsellImage.alt = color;
      upsellImage.classList.toggle('is-beige', color === 'Beżowy');
    });
  }

  setText('[data-upsell-summary-color]', color);
};

const normalizeOption = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '');

const findVariantId = (variants, size, color) => {
  const normalizedSize = normalizeOption(size);
  const normalizedColor = normalizeOption(color);

  const variant = variants.find((item) => {
    const options = (item.options || []).map(normalizeOption);
    const optionText = options.join(' ');

    return (
      options.includes(normalizedSize) && options.includes(normalizedColor)
    ) || (
      optionText.includes(normalizedSize) && optionText.includes(normalizedColor)
    );
  });

  return variant?.id;
};

const findSelectedVariantId = () => findVariantId(
  bowllyVariants,
  getSelectedOrderSize(),
  getSelectedOrderColor()
);

const findSelectedUpsellVariantId = () => findVariantId(
  bowllyUpsellVariants,
  getSelectedOrderSize(),
  getSelectedUpsellColor()
);

const addCartItem = async (item, fallbackMessage) => {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: [item] })
  });

  if (!response.ok) {
    let detail = '';

    try {
      const error = await response.json();
      detail = error?.description || error?.message || '';
    } catch (error) {
      detail = '';
    }

    throw new Error(detail || fallbackMessage);
  }
};

const getSelectedDeliveryOption = () => {
  const selected = document.querySelector('[data-delivery-provider].is-selected');

  return {
    provider: selected?.dataset.deliveryProvider || 'InPost',
    method: selected?.dataset.deliveryMethod || 'Paczkomat'
  };
};

const setCheckoutButtonLoading = (isLoading, label = 'Dodawanie do koszyka...') => {
  const checkoutButton = document.querySelector('[data-order-checkout]');

  if (!checkoutButton) {
    return;
  }

  if (isLoading) {
    checkoutButton.dataset.originalText = checkoutButton.dataset.originalText || checkoutButton.textContent;
    checkoutButton.textContent = label;
    checkoutButton.setAttribute('aria-busy', 'true');
  } else {
    checkoutButton.textContent = checkoutButton.dataset.originalText || 'Opłać zamówienie';
    checkoutButton.removeAttribute('aria-busy');
  }
};

const setDeliveryError = (message) => {
  const error = document.querySelector('[data-delivery-error]');

  if (error) {
    error.textContent = message;
    error.hidden = false;
  }
};

const clearDeliveryError = () => {
  const error = document.querySelector('[data-delivery-error]');

  if (error) {
    error.hidden = true;
  }
};

const getPointAddress = (point) => {
  if (point.address_details) {
    return [
      [point.address_details.street, point.address_details.building_number].filter(Boolean).join(' '),
      [point.address_details.post_code, point.address_details.city].filter(Boolean).join(' ')
    ].filter(Boolean).join(', ');
  }

  if (point.address) {
    return [point.address.line1, point.address.line2].filter(Boolean).join(', ');
  }

  return 'Adres punktu InPost';
};

const translatePointDescription = (value) => {
  if (!value) {
    return '';
  }

  const replacements = [
    [/^at\s+/i, 'Przy '],
    [/^near\s+/i, 'Obok '],
    [/^next to\s+/i, 'Obok '],
    [/^in front of\s+/i, 'Przed '],
    [/^behind\s+/i, 'Za '],
    [/^inside\s+/i, 'W środku '],
    [/^opposite\s+/i, 'Naprzeciwko '],
    [/parking lot/gi, 'parking'],
    [/entrance/gi, 'wejściu'],
    [/shop/gi, 'sklepie'],
    [/store/gi, 'sklepie'],
    [/market/gi, 'markecie'],
    [/building/gi, 'budynku']
  ];

  return replacements.reduce((text, [pattern, replacement]) => text.replace(pattern, replacement), value).trim();
};

const getPointDescription = (point) => translatePointDescription(
  point.location_description_1 ||
  point.location_description_2 ||
  point.location_description ||
  point.opening_hours ||
  ''
);

const normalizeDeliveryText = (value) => (value || '')
  .toString()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, ' ')
  .trim();

const toPolishTitleCase = (value) => normalizeDeliveryText(value)
  .split(' ')
  .filter(Boolean)
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  .join(' ');

const getPointSearchText = (point) => normalizeDeliveryText([
  point.name,
  point.display_name,
  getPointAddress(point),
  getPointDescription(point)
].filter(Boolean).join(' '));

const getDeliveryFunctions = () => {
  const method = getSelectedDeliveryOption().method;

  return method === 'Paczkomat' ? 'parcel_collect' : 'parcel_collect';
};

const fetchInPostPoints = async (params) => {
  const url = new URL('https://api-shipx-pl.easypack24.net/v1/points');

  url.searchParams.set('per_page', '50');
  url.searchParams.set('status', 'Operating');
  url.searchParams.set('functions', getDeliveryFunctions());

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      url.searchParams.set(key, value);
    }
  });

  const response = await fetch(url.toString());

  if (!response.ok) {
    return [];
  }

  const data = await response.json();
  return Array.isArray(data.items) ? data.items : [];
};

const uniqueDeliveryPoints = (points) => {
  const unique = new Map();

  points.forEach((point) => {
    const key = point.name || point.display_name;

    if (key && !unique.has(key)) {
      unique.set(key, point);
    }
  });

  return [...unique.values()];
};

const buildDeliverySearchRequests = (query) => {
  const trimmed = query.trim();
  const normalized = normalizeDeliveryText(trimmed);
  const postcode = trimmed.match(/\b\d{2}-?\d{3}\b/)?.[0]?.replace(/(\d{2})(\d{3})/, '$1-$2');
  const words = normalized.split(' ').filter((word) => word.length > 1);
  const pointCode = trimmed.toUpperCase().match(/\b[A-Z]{1,5}\d[A-Z0-9-]{1,12}\b/)?.[0];
  const requests = [{ query: trimmed }];

  if (pointCode) {
    requests.push({ query: pointCode });
    requests.push({ name: pointCode });
  }

  if (postcode) {
    requests.push({ query: postcode });
    requests.push({ relative_post_code: postcode });
  }

  words.forEach((word) => {
    if (word.length > 2) {
      requests.push({ query: word });
    }
  });

  if (words.length) {
    requests.push({ city: toPolishTitleCase(words[words.length - 1]) });
  }

  return requests;
};

const rankDeliveryPoints = (points, query) => {
  const tokens = normalizeDeliveryText(query).split(' ').filter((token) => token.length > 1);

  return points
    .map((point) => {
      const text = getPointSearchText(point);
      const name = normalizeDeliveryText(point.name);
      const displayName = normalizeDeliveryText(point.display_name);
      let score = typeof point._bowllyNearestRank === 'number' ? 80 - point._bowllyNearestRank : 0;

      tokens.forEach((token) => {
        if (name.includes(token)) score += 8;
        if (displayName.includes(token)) score += 6;
        if (text.includes(token)) score += 3;
      });

      return { point, score };
    })
    .filter((item) => !tokens.length || item.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((item) => item.point);
};

const setDeliveryResultsMessage = (message) => {
  const results = document.querySelector('[data-delivery-results]');

  if (!results) {
    return;
  }

  results.hidden = false;
  results.textContent = message;
};

const renderDeliveryResults = (points, query = '') => {
  const results = document.querySelector('[data-delivery-results]');

  if (!results) {
    return;
  }

  deliveryPointStore = new Map();
  results.textContent = '';

  const rankedPoints = uniqueDeliveryPoints(points).slice(0, 10);

  if (!rankedPoints.length) {
    setDeliveryResultsMessage('Nie znaleźliśmy punktu. Spróbuj wpisać numer Paczkomatu, kod pocztowy albo samo miasto.');
    return;
  }

  rankedPoints.forEach((point) => {
    const pointId = point.name || point.display_name;
    const button = document.createElement('button');
    const title = document.createElement('strong');
    const address = document.createElement('span');
    const description = document.createElement('span');

    deliveryPointStore.set(pointId, point);
    button.type = 'button';
    button.className = 'dtc-delivery-result';
    button.dataset.deliveryResult = pointId;
    title.textContent = `${point.name || point.display_name}${point.display_name && point.display_name !== point.name ? ` · ${point.display_name}` : ''}`;
    address.textContent = getPointAddress(point);
    description.textContent = getPointDescription(point);

    button.append(title, address);

    if (description.textContent) {
      button.append(description);
    }

    results.append(button);
  });

  results.hidden = false;
};

const searchDeliveryPoints = async () => {
  const input = document.querySelector('[data-delivery-search]');
  const query = input?.value.trim() || '';

  if (query.length < 2) {
    setDeliveryError('Wpisz minimum 2 znaki: miasto, adres, kod albo numer punktu.');
    input?.focus();
    return;
  }

  clearDeliveryError();
  selectedDeliveryPoint = null;
  document.querySelector('[data-delivery-selected]')?.setAttribute('hidden', '');
  setDeliveryResultsMessage('Szukamy punktów...');

  const searchResponses = await Promise.allSettled(buildDeliverySearchRequests(query).map(fetchInPostPoints));
  const points = searchResponses.flatMap((response) => response.status === 'fulfilled' ? response.value : []);

  renderDeliveryResults(points, query);
};

const selectDeliveryPoint = (point) => {
  const { provider, method } = getSelectedDeliveryOption();
  const selected = document.querySelector('[data-delivery-selected]');
  const pointId = point.name || point.display_name || '';
  const pointAddress = getPointAddress(point);

  selectedDeliveryPoint = {
    provider,
    method,
    id: pointId,
    address: pointAddress,
    description: getPointDescription(point)
  };

  if (selected) {
    selected.hidden = false;
    selected.textContent = `✓ Wybrano ${method}
${selectedDeliveryPoint.id}
${selectedDeliveryPoint.address}
${selectedDeliveryPoint.description ? `${selectedDeliveryPoint.description}\n` : ''}Przewoźnik: ${provider}`;
  }

  clearDeliveryError();
};

const markCartAsChanged = () => {
  isCartPreparedForCheckout = false;
};

const prepareCartForCheckout = async () => {
  const nameInput = document.querySelector('[data-dog-name-input]');
  const warning = document.querySelector('[data-order-warning]');
  const dogName = nameInput?.value.trim().toUpperCase();
  const selectedSize = getSelectedOrderSize();
  const selectedColor = getSelectedOrderColor();
  const selectedUpsellColor = getSelectedUpsellColor();
  const variantId = findSelectedVariantId();
  const hasUpsell = document.querySelector('[data-upsell-toggle]')?.checked;
  const items = [];

  if (!dogName) {
    if (warning) {
      warning.hidden = false;
    }
    nameInput?.focus();
    return false;
  }

  if (!variantId) {
    if (warning) {
      warning.textContent = 'Wybrany wariant jest niedostępny. Zmień rozmiar lub kolor.';
      warning.hidden = false;
    }
    return false;
  }

  items.push({
    id: variantId,
    quantity: 1,
    properties: {
      'Imię pupila': dogName,
      'Rozmiar': selectedSize,
      'Kolor': selectedColor
    }
  });

  if (bowllyGiftVariant?.id && bowllyGiftVariant.available !== false) {
    items.push({
      id: String(bowllyGiftVariant.id),
      quantity: 1,
      properties: {
        'Gratis': 'Łyżeczka do karmy',
        'Wartość': '30 zł'
      }
    });
  }

  if (hasUpsell) {
    const upsellVariantId = findSelectedUpsellVariantId();

    if (!upsellVariantId) {
      if (warning) {
        warning.textContent = 'Nie udało się dodać drugiej miski. Zmień rozmiar lub kolor albo spróbuj ponownie.';
        warning.hidden = false;
      }
      return false;
    }

    items.push({
      id: upsellVariantId,
      quantity: 1,
      properties: {
        'Typ': 'Druga miska na wodę',
        'Rabat': '25%',
        'Imię pupila': dogName,
        'Rozmiar': selectedSize,
        'Kolor': selectedUpsellColor
      }
    });
  }

  if (warning) {
    warning.hidden = true;
  }

  await fetch('/cart/clear.js', { method: 'POST' });

  for (const item of items) {
    const itemType = item.properties?.Typ || item.properties?.Gratis || 'Miska';
    await addCartItem(item, `Nie udało się dodać pozycji: ${itemType}.`);
  }

  isCartPreparedForCheckout = true;
  return true;
};

const saveDeliveryAndCheckout = async () => {
  if (!selectedDeliveryPoint?.id || !selectedDeliveryPoint?.address) {
    setDeliveryError('Wybierz punkt dostawy z listy przed płatnością.');
    document.querySelector('[data-delivery-block]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  clearDeliveryError();
  setCheckoutButtonLoading(true, 'Zapisywanie...');

  const cartPrepared = isCartPreparedForCheckout || await prepareCartForCheckout();

  if (!cartPrepared) {
    setCheckoutButtonLoading(false);
    return;
  }

  const deliveryNote = [
    `Dostawa: ${selectedDeliveryPoint.provider} — ${selectedDeliveryPoint.method}`,
    `Punkt odbioru: ${selectedDeliveryPoint.id}`,
    `Adres punktu: ${selectedDeliveryPoint.address}`,
    selectedDeliveryPoint.description ? `Opis punktu: ${selectedDeliveryPoint.description}` : ''
  ].filter(Boolean).join('\n');

  const deliveryAttributes = {
    'Przewoźnik': selectedDeliveryPoint.provider,
    'Sposób dostawy': selectedDeliveryPoint.method,
    'Punkt odbioru': selectedDeliveryPoint.id,
    'Adres punktu': selectedDeliveryPoint.address,
    'Opis punktu': selectedDeliveryPoint.description || ''
  };

  const updateResponse = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      note: deliveryNote,
      attributes: deliveryAttributes
    })
  });

  if (!updateResponse.ok) {
    setCheckoutButtonLoading(false);
    setDeliveryError('Nie udało się zapisać punktu. Spróbuj ponownie.');
    return;
  }

  const updatedCart = await updateResponse.json();

  if (
    updatedCart.note !== deliveryNote ||
    Object.entries(deliveryAttributes).some(([key, value]) => (updatedCart.attributes?.[key] || '') !== value)
  ) {
    setCheckoutButtonLoading(false);
    setDeliveryError('Nie udało się potwierdzić punktu. Spróbuj ponownie.');
    return;
  }

  window.location.href = '/checkout';
};

const syncOrderSize = (size, priceText) => {
  const orderButton = document.querySelector(`[data-order-size="${size}"]`);

  if (!orderButton) {
    return;
  }

  document.querySelectorAll('[data-order-size]').forEach((button) => {
    button.classList.toggle('is-selected', button === orderButton);
  });

  setText('[data-order-summary-size]', size);
  setText('[data-order-summary-price]', priceText || orderButton.dataset.price || '');
  updateUpsellPrice(size);
  updateOrderTotal();
};

const syncConfiguratorPanel = (size) => {
  document.querySelectorAll('[data-size-panel-tab]').forEach((button) => {
    button.classList.toggle('is-active', button.dataset.sizePanelTab === size);
  });

  document.querySelectorAll('[data-size-panel-content]').forEach((panel) => {
    panel.classList.toggle('is-active', panel.dataset.sizePanelContent === size);
  });
};

const updateUpsellPrice = (size) => {
  const basePrice = orderPrices[size] || 109;
  const upsellPrice = basePrice * 0.75;

  setText('[data-upsell-price]', formatZloty(upsellPrice));
  setText('[data-upsell-compare]', formatZloty(basePrice));
  setText('[data-upsell-footer-price]', formatZloty(upsellPrice));
  setText('[data-upsell-summary-price]', formatZloty(upsellPrice));
};

const updateOrderTotal = () => {
  const selectedSize = getSelectedOrderSize();
  const basePrice = orderPrices[selectedSize] || 109;
  const hasUpsell = document.querySelector('[data-upsell-toggle]')?.checked;
  const total = hasUpsell ? basePrice + basePrice * 0.75 : basePrice;

  setText('[data-order-total]', formatZloty(total));
  updateShippingProgress(total);
};

const updateShippingProgress = (total) => {
  const text = document.querySelector('[data-shipping-text]');
  const fill = document.querySelector('[data-shipping-fill]');
  const remaining = Math.max(0, freeShippingThreshold - total);
  const progress = Math.min(100, Math.round((total / freeShippingThreshold) * 100));

  if (text) {
    text.textContent = remaining > 0
      ? `Do darmowej dostawy brakuje ${formatZloty(remaining)}`
      : '✓ Dostawa jest darmowa';
  }

  if (fill) {
    fill.style.width = `${progress}%`;
  }
};

document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.dtc-swatches button');

  if (swatch) {
    swatch.parentElement.querySelectorAll('button').forEach((button) => {
      button.classList.toggle('is-active', button === swatch);
    });

    const form = swatch.closest('form');
    const colorInput = form?.querySelector('.dtc-builder-form__color-property');

    if (colorInput && swatch.dataset.color) {
      colorInput.value = swatch.dataset.color;
    }
  }

  const sizeCard = event.target.closest('.dtc-size-card');

  if (sizeCard) {
    const form = sizeCard.closest('form');
    const variantInput = form?.querySelector('.dtc-builder-form__variant');
    const priceTarget = form?.querySelector('[data-builder-price]');

    form?.querySelectorAll('.dtc-size-card').forEach((card) => {
      const isCurrent = card === sizeCard;
      card.classList.toggle('is-active', isCurrent);
      card.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
    });

    if (variantInput && sizeCard.dataset.variantId) {
      variantInput.value = sizeCard.dataset.variantId;
    }

    if (priceTarget && sizeCard.dataset.price) {
      priceTarget.textContent = sizeCard.dataset.price;
    }

    if (sizeCard.dataset.size) {
      syncConfiguratorPanel(sizeCard.dataset.size);
      syncOrderSize(sizeCard.dataset.size, sizeCard.dataset.price);
      markCartAsChanged();
    }
  }

  const sizePanelTab = event.target.closest('[data-size-panel-tab]');

  if (sizePanelTab) {
    const size = sizePanelTab.dataset.sizePanelTab;
    const form = sizePanelTab.closest('form');
    const sizeCardButton = form?.querySelector(`.dtc-size-card[data-size="${size}"]`);

    if (sizeCardButton) {
      sizeCardButton.click();
    }
  }

  const orderSize = event.target.closest('[data-order-size]');

  if (orderSize) {
    syncOrderSize(orderSize.dataset.orderSize, orderSize.dataset.price);
    markCartAsChanged();
  }

  const orderColor = event.target.closest('[data-order-color]');

  if (orderColor) {
    document.querySelectorAll('[data-order-color]').forEach((button) => {
      button.classList.toggle('is-selected', button === orderColor);
    });

    setText('[data-order-summary-color]', orderColor.dataset.orderColor);

    const summaryImage = document.querySelector('[data-order-summary-image]');
    if (summaryImage && orderColor.dataset.colorImage) {
      summaryImage.src = orderColor.dataset.colorImage;
      summaryImage.alt = orderColor.dataset.orderColor;
    }

    updateUpsellColorDisplay();

    markCartAsChanged();
  }

  const upsellColor = event.target.closest('[data-upsell-color]');

  if (upsellColor) {
    document.querySelectorAll('[data-upsell-color]').forEach((button) => {
      button.classList.toggle('is-selected', button === upsellColor);
    });

    updateUpsellColorDisplay();
    markCartAsChanged();
  }

  const checkoutButton = event.target.closest('[data-order-checkout]');

  if (checkoutButton) {
    event.preventDefault();
    saveDeliveryAndCheckout().catch((error) => {
      setCheckoutButtonLoading(false);
      setDeliveryError(error?.message || 'Nie udało się przejść do płatności. Spróbuj ponownie.');
    });
  }

  const deliveryOption = event.target.closest('[data-delivery-provider]');

  if (deliveryOption) {
    document.querySelectorAll('[data-delivery-provider]').forEach((button) => {
      button.classList.toggle('is-selected', button === deliveryOption);
    });
    selectedDeliveryPoint = null;
    document.querySelector('[data-delivery-selected]')?.setAttribute('hidden', '');
    clearDeliveryError();
  }

  const deliverySearchButton = event.target.closest('[data-delivery-search-button]');

  if (deliverySearchButton) {
    searchDeliveryPoints().catch(() => {
      setDeliveryError('Nie udało się pobrać punktów InPost. Spróbuj ponownie.');
    });
  }

  const deliveryResult = event.target.closest('[data-delivery-result]');

  if (deliveryResult) {
    const point = deliveryPointStore.get(deliveryResult.dataset.deliveryResult);

    if (point) {
      document.querySelectorAll('[data-delivery-result]').forEach((button) => {
        button.classList.toggle('is-selected', button === deliveryResult);
      });
      selectDeliveryPoint(point);
    }
  }
});

document.addEventListener('input', (event) => {
  const nameInput = event.target.closest('[data-dog-name-input]');

  if (nameInput) {
    const value = nameInput.value.trim().toUpperCase();
    nameInput.value = value;
    setText('[data-order-summary-name]', value || '—');

    const warning = document.querySelector('[data-order-warning]');
    if (warning) {
      warning.hidden = Boolean(value);
    }

    markCartAsChanged();
  }
});

document.addEventListener('keydown', (event) => {
  const searchInput = event.target.closest('[data-delivery-search]');

  if (searchInput && event.key === 'Enter') {
    event.preventDefault();
    searchDeliveryPoints().catch(() => {
      setDeliveryError('Nie udało się pobrać punktów InPost. Spróbuj ponownie.');
    });
  }
});

document.addEventListener('change', (event) => {
  const upsellToggle = event.target.closest('[data-upsell-toggle]');

  if (upsellToggle) {
    const controls = document.querySelector('[data-upsell-controls]');
    const summary = document.querySelector('[data-upsell-summary]');

    if (controls) {
      controls.hidden = !upsellToggle.checked;
    }

    if (summary) {
      summary.hidden = !upsellToggle.checked;
    }

    updateUpsellColorDisplay();
    updateOrderTotal();
    markCartAsChanged();
  }

  const upsellColorMode = event.target.closest('[name="upsell-color-mode"]');

  if (upsellColorMode) {
    const colorOptions = document.querySelector('[data-upsell-color-options]');

    if (colorOptions) {
      colorOptions.hidden = upsellColorMode.value !== 'different';
    }

    updateUpsellColorDisplay();
    markCartAsChanged();
  }

  updateOrderTotal();
});

updateOrderTotal();
updateUpsellColorDisplay();
